// extracted by mini-css-extract-plugin
export var boxItems = "_28-1";
export var boxItemsLg = "_28-2";
export var button = "_28-7";
export var buttonHoverless = "_28-9";
export var buttonLg = "_28-8";
export var filterGroupBox = "_28-0";
export var icon = "_28-3";
export var iconSecondary = "_28-6";
export var iconWrapper = "_28-4";
export var iconWrapperLg = "_28-5";
export var truncatedLabel = "_28-a";